<template>
    <div class="changewarp">
        <Header title="成绩"></Header>
        <div class="changecontent">
            <div class="header">
                <div class="ht">
                    <div class="name">{{ this.xm }}</div>
                    <div class="num">({{ this.xh }})</div>
                </div>
                <div class="hb">
                    <div>年级：{{ this.xsnj }}</div>
                    <div>班级：{{ this.bj }}</div>
                </div>
            </div>
            <div class="list">
                <div class="listBox">
                    <div class="package">
                        <div class="gradeBox">
                            <div class="grade" @click="clickGrade">
                                {{ this.njmc == '' ? '年级' : this.njmc }}
                                <div class="jiantou"></div>
                            </div>
                            <van-popup v-model="showPicker" position="bottom">
                                <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
                            </van-popup>
                        </div>
                        <div class="tableBox" style="padding:12px 15px">
                            <el-table :data="tableData" fit border style="width: 100%;" :header-cell-style="{ background: '#E1E4E9' }">
                                <el-table-column type="index" width="50"></el-table-column>
                                <el-table-column prop="kcmc" label="课程">
                                    <template slot-scope="scope">
                                        <div @click="showPopup(scope.row)">{{ scope.row.kcmc }}</div>
                                        <van-popup v-model="show" closeable round>
                                            <div class="springFrame">
                                                <div class="title">{{ choiceItem.kcmc }}</div>
                                                <ul>
                                                    <li>课程号:{{ choiceItem.kcbh }}</li>
                                                    <li>课程名称：{{ choiceItem.kcmc }}</li>
                                                    <li>学分：{{ choiceItem.xf }}</li>
                                                    <li>学时：{{ choiceItem.zxs }}</li>
                                                    <li>课程属性：{{ choiceItem.kcsxmc }}</li>
                                                    <li>课程性质：{{ choiceItem.kcxzmc }}</li>
                                                    <li>总成绩：{{ choiceItem.zcj }}</li>
                                                    <li>原始总成绩：{{ choiceItem.yszcj }}</li>
                                                    <li>通选课类别：{{ choiceItem.txklb }}</li>
                                                    <li>成绩标识：{{ choiceItem.cjbsmz }}</li>
                                                    <li>学期：{{ choiceItem.xqmc }}</li>
                                                    <li>考试性质：{{ choiceItem.ksxzmc }}</li>
                                                </ul>
                                                <button @click="show = false">知道了</button>
                                            </div>
                                        </van-popup>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="xf" label="学分"> </el-table-column>
                                <el-table-column prop="zcj" label="成绩"> </el-table-column>
                                <el-table-column prop="kcxzmc" label="考试性质"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Api } from '../../../../utils/axios';

export default {
    data() {
        return {
            //年级
            showPicker: false,
            columns: [],
            njmc: '',
            tableData: [],
            show: false,
            xsydList: '',
            xm: '',
            xh: '',
            xsnj: '',
            bj: '',
            choiceItem: {}
        };
    },
    created() {
        //获取年级

        this.xsydList = this.$route.query.xs0101id;
        this.xm = this.$route.query.xm;
        this.xh = this.$route.query.xh;
        this.xsnj = this.$route.query.xsnj;
        this.bj = this.$route.query.bj;
        this.getXnxq(() => {
            this.getXsxxckcj();
        });
    },
    methods: {
        //获取年级
        async getXnxq(callback) {
            const gradeResults = await Api.getXnxq();
            // 首先这个第0条  是你给我的信息 ， 我没改
            let target = gradeResults.data.find((item) => +item.isdqxq === 1);
            target = target || gradeResults.data[0];
            this.njmc = target.xnxq01id;
            for (let i = 0; i < gradeResults.data.length; i++) {
                this.columns.push(gradeResults.data[i].xnxq01id);
            }
            callback && callback();
        },
        clickGrade() {
            this.showPicker = true;
        },
        onConfirm(value) {
            console.log('value:', value);
            this.njmc = value;
            this.showPicker = false;
            this.getXsxxckcj();
        },
        //弹框
        showPopup(row) {
            this.choiceItem = row;
            this.show = true;
        },
        async getXsxxckcj() {
            const params = {
                xs0101id: this.xsydList,
                xnxq01id: this.njmc
            };
            const res = await Api.getXsxxckcj(params);
            this.tableData = res.data;
        }
    }
};
</script>

<style scoped lang="less">
.changewarp {
    .changecontent {
        .header {
            .ht {
                display: flex;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                margin-left: 26px;
            }
            .hb {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                margin-top: 5px;
                margin-left: 24px;
                padding-bottom: 12px;
                div {
                    padding: 0px 7px 0 0;
                }
            }
        }
        .list {
            width: 100%;
            height: 100vh;
            background: #f6f6f6;
            .listBox {
                width: 100%;
                display: flex;
                justify-content: center;
                align-content: center;
                .package {
                    width: 100%;
                    background: #ffffff;
                    margin-top: 10px;
                    .gradeBox {
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        padding-top: 15px;
                        .jiantou {
                            display: inline-block;
                            border-bottom: 1px solid;
                            border-left: 1px solid;
                            width: 5px;
                            height: 5px;
                            border-color: #b2b2b2;
                            transform: rotate(-45deg);
                            transition: all 0.4s ease;
                            margin: 3px;
                        }
                    }
                }
            }
        }
    }
}
</style>
<style lang="less">
.tableBox {
    .el-table {
        .el-table__body-wrapper {
            tbody {
                tr {
                    td:nth-child(2) {
                        .cell {
                            color: #0189f9;
                        }
                        .springFrame {
                            width: 100%;
                            height: 100%;
                            .title {
                                font-weight: 500;
                                font-size: 18px;
                                color: #333333;
                                line-height: 18px;
                                margin: 20px;
                            }
                            ul {
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                line-height: 21px;
                                margin: 10px 20px;
                                li {
                                    margin: 2px 0;
                                }
                                .newli {
                                    font-weight: 500;
                                    color: #333333;
                                }
                            }
                            button {
                                width: 271px;
                                height: 42px;
                                background: #0189f9;
                                border-radius: 4px;
                                color: #ffffff;
                                margin: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/informationService/achievement.vue